import { envConfig } from './env.config';

// API Configuration
export const environment = {
  API: envConfig.API_URL,
}; 